import React from 'react';

const Breadcrew = ({ data }) => {
	return (
		<>
			<div className='breadscrumb'>
				<ul className='bradscrumb-nav'>
					{data.map(({ name, url }, index) => (
						<li key={index}>
							{url ? (
								<a href={url}>{name}</a>
							) : (
								<a className='active'>{name}</a>
							)}
						</li>
					))}
				</ul>
			</div>
		</>
	);
};
export default Breadcrew;
